import React from "react";
import { Box } from "@mui/joy";
import { useString } from "../../utils/String";
import { Icon } from "../../assets";
import { Tag } from ".";
import { useResolvedMediaSrc } from 'src/mtska-frontend-data-provider/hooks/useResolvedMediaSrc';

const LegalEntityAvatar = ({ name, size = "default", url = null, onClick, withname = false, detail = false, error = false, style }) => {

    const { firstCharacter, toColor } = useString();
    const { src, ready } = useResolvedMediaSrc(url);

    const showImage = url && ready;

    return (
        <Box className={"company-avatar-wrapper company-avatar-withname-" + withname + ((error) ? ' company-avatar-error' : '')} onClick={onClick} style={style}>
            <Box className={"company-avatar company-avatar-" + size} style={{backgroundColor: showImage ? 'white' : (error ? 'var(--danger-400)' : toColor(name+name))}}>
                {showImage && (
                    <img src={src} alt="" />
                )}
                {!showImage && !error && (
                    <span className="name" title={name}>{firstCharacter(name).toUpperCase()}</span>
                )}
                {!showImage && error && (
                    <span className="name" title={name}><Icon icon={"faWarning"} /></span>
                )}
            </Box>
            {(withname && !error) && (
                <Box className={"company-name"+(detail ? ' hasdetail' : '')}>
                    <span className="fullname" title={name}>{(name)}</span>
                    {
                        detail && (
                            <span className="detail">{(detail)}</span>
                        )
                    }
                </Box>
            )}
            {(withname && error) && (
                <Tag color={"danger"} title={error}><Icon icon="faWarning" />{error}</Tag>
            )}
        </Box>
    )
}

export default LegalEntityAvatar;
